import { DashboardShiftRequestDto } from './../dtos/dashboard.dto';
export const mockDashboardShiftRequests: DashboardShiftRequestDto[] = [
  {
    id: '7c9a8e2b-5a41-4f45-9f35-3c6f8d7a2c11',
    shiftNeedId: 'b4f0a7c2-3c9b-4c88-9d7b-9a4c1e7b0d52',
    contractorId: '0f6c2d3e-2c18-4b6e-9a1f-2d8c0f4b3a9d',
    contractorName: 'Alex Johnson',
    latestCounterOfferRate: 58,
    message: 'I’m available and can arrive 15 minutes early.',
    status: 'pending',
    requestedAt: '2026-02-15T18:22:10.000Z',
    facilityId: 'd2c1f1a9-7c2a-4a9c-8f8b-5b9a7d1c3e44',
    facilityName: 'Wasatch Valley Medical Center',
    facilitySubtypeId: 2,
    facilitySubtypeName: 'Hospital',
    facilityFullAddress: '1200 E 3900 S, Salt Lake City, UT 84124, USA',
    location: 'Salt Lake City, UT',
    distanceMiles: 8.4,
    scopeOfPractice: 3,
    scopeOfPracticeDisplay: 'Registered Nurse (RN)',
    shiftType: 'night',
    shiftTypeDisplay: 'Night Shift',
    shiftDate: '2026-02-20',
    startTime: '19:00:00',
    endTime: '07:00:00',
    shiftNeedHourlyRate: 55,
    estimatedHours: 12,
    estimatedPayment: 660,
    rateInfo: {
      contractorNormalHourlyRate: 58,
      contractorNormalEstimatedPayment: 696,
      contractorUrgentHourlyRate: null,
      contractorUrgentEstimatedPayment: null,
      facilityNormalHourlyRate: 55,
      facilityNormalEstimatedPayment: 660,
      facilityUrgentHourlyRate: null,
      facilityUrgentEstimatedPayment: null
    },
    initiatedBy: 'contractor',
    createdBy: 'contractor',
    createdByName: 'Alex Johnson',
    expiresAt: '2026-02-19T23:59:59.000Z',
    numberOfPositions: 2
  },
  {
    id: '1a3d7b9c-6e2f-4d1a-8c44-8f1e0a9c7d33',
    shiftNeedId: '9f2c6a1d-8c77-4f4b-a9c1-6c2f8a1b0e91',
    contractorId: '6d9f2b1c-4b7a-4d0a-9a12-0f9b7c1e3a22',
    contractorName: 'Maria Thompson',
    latestCounterOfferRate: 42,
    message:
      'Can confirm availability for this shift. Please advise parking instructions.',
    status: 'accepted',
    requestedAt: '2026-02-10T15:05:44.000Z',
    respondedAt: '2026-02-10T16:12:03.000Z',
    responseMessage:
      'Accepted. Please check in at the main entrance 10 minutes before start.',
    facilityId: '5c1b8a3d-2b5a-4d9f-9c31-7a2f0b6e1d90',
    facilityName: 'Provo Care & Rehab',
    facilitySubtypeId: 5,
    facilitySubtypeName: 'Skilled Nursing Facility',
    facilityFullAddress: '450 W 800 N, Provo, UT 84604, USA',
    location: 'Provo, UT',
    distanceMiles: 4.1,
    scopeOfPractice: 2,
    scopeOfPracticeDisplay: 'Licensed Practical Nurse (LPN)',
    shiftType: 'day',
    shiftTypeDisplay: 'Day Shift',
    shiftDate: '2026-02-18',
    startTime: '07:00:00',
    endTime: '15:00:00',
    shiftNeedHourlyRate: 40,
    estimatedHours: 8,
    estimatedPayment: 320,
    rateInfo: {
      contractorNormalHourlyRate: 42,
      contractorNormalEstimatedPayment: 336,
      contractorUrgentHourlyRate: null,
      contractorUrgentEstimatedPayment: null,
      facilityNormalHourlyRate: 40,
      facilityNormalEstimatedPayment: 320,
      facilityUrgentHourlyRate: null,
      facilityUrgentEstimatedPayment: null
    },
    initiatedBy: 'facility',
    createdBy: 'facility',
    createdByName: 'Staffing Coordinator',
    expiresAt: '2026-02-18T05:00:00.000Z',
    numberOfPositions: 1
  }
];
